import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import RestoreIcon from '@mui/icons-material/Restore';
import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../icons/OnDeleteIcon';
import OnEditIcon from '../../icons/OnEditIcon';
import OnFileDownloadIcon from '../../icons/OnFileDownloadIcon';
import { formatDateTime, reverseFormatDate } from '../../utils/dateFunctions';
import { hasRole, QUALITY, SUPERUSER } from '../../utils/userRoles';

const deleteRoles = [QUALITY, SUPERUSER];

import table from '../../commonStyles/tables.module.css';

const DocumentsTableRow = ({
    row,
    roles,
    acceptedRoles,
    onEdit,
    onDelete,
    onDownload,
    isAuditable,
    onSearchAuditItems
}) => {
    // LOCAL STATE
    const [editRoles, setEditRoles] = useState(acceptedRoles);

    // STORE STATE
    const contractConstants = useSelector(
        (state) => state.entities.participantService.contractConstants
    );
    const claimQueues = useSelector((state) => state.entities.participantService.claimQueues);
    const claimQueuesMetaData = useSelector(
        (state) => state.entities.participantService.claimQueuesMetaData
    );

    // USEEFFECTS
    useEffect(() => {
        if (
            !claimQueuesMetaData?.last ||
            claimQueues.length < 1 ||
            Object.keys(contractConstants).length < 1
        )
            return;
        // only need to restrict if PT has none of the restricted claimStatuses
        if (contractConstants.activeStatusDocumentTypeIds.includes(row.typeId))
            setEditRoles([QUALITY, SUPERUSER]);
    }, [claimQueues, claimQueuesMetaData, contractConstants]);

    // RENDER
    return (
        <TableRow className={`${table.basicRowStripes}`}>
            <TableCell>{row.filename}</TableCell>
            <TableCell>
                <div>
                    {row.type}
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={() => onSearchAuditItems(row.id, 'Document Type')}
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell>{reverseFormatDate(row.dateCreated)}</TableCell>
            <TableCell>{row.time}</TableCell>
            <TableCell>{row.userName}</TableCell>
            <TableCell>{formatDateTime(row.dateModified)}</TableCell>
            <TableCell>{row.status === 'QUARANTINED' ? 'FAILED' : row.status}</TableCell>
            <TableCell align="right">
                <OnFileDownloadIcon
                    active={row.status === 'READY' && hasRole(acceptedRoles, roles)}
                    onDownload={() => onDownload(row)}
                />
            </TableCell>
            <TableCell align="right">
                <OnEditIcon
                    active={row.status === 'READY' && hasRole(editRoles, roles)}
                    onEdit={(e) => onEdit(e, row)}
                />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon
                    active={row.status === 'READY' && hasRole(deleteRoles, roles)}
                    onDelete={() => onDelete(row)}
                />
            </TableCell>
        </TableRow>
    );
};

DocumentsTableRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func
};

export default DocumentsTableRow;
